/**
 * Params represent dynamic values passed as route params
 */
export enum RouteParam {
  lang = 'param_lang',
  articleId = 'param_articleId',
}

/**
 * QueryParams represent query params (e.g. ?key=value)
 */
export enum SearchParam {
  count = 'count',
  page = 'page',
  articleId = 'articleId',
  weightKg = 'weightKg',
  container = 'container',
  query = 'query',
  glosses = 'glosses',
  surfaces = 'surfaces',
  categories = 'categories',
  emailToDelete = 'emailToDelete',
  companyName = 'companyName',
  colorRanges = 'colorRanges',
  weatherResistances = 'weatherResistances',
  effects = 'effects',
  seriesNumbers = 'seriesNumbers',
  specialProperties = 'specialProperties',
  certificates = 'certificates',
  storedAddressId = 'storedAddressId',
}

export const SEARCH_PARAM_TYPE_MAPPING = {
  [SearchParam.count]: 'number',
  [SearchParam.page]: 'number',
  [SearchParam.query]: 'string',
  [SearchParam.articleId]: 'string',
  [SearchParam.weightKg]: 'string',
  [SearchParam.container]: 'string',
  [SearchParam.emailToDelete]: 'string',
  [SearchParam.companyName]: 'string',
  [SearchParam.glosses]: 'string[]',
  [SearchParam.surfaces]: 'string[]',
  [SearchParam.categories]: 'string[]',
  [SearchParam.colorRanges]: 'string[]',
  [SearchParam.weatherResistances]: 'string[]',
  [SearchParam.effects]: 'string[]',
  [SearchParam.seriesNumbers]: 'string[]',
  [SearchParam.specialProperties]: 'string[]',
  [SearchParam.certificates]: 'string[]',
  [SearchParam.storedAddressId]: 'number',
} satisfies Record<SearchParam, 'string' | 'string[]' | 'number'>;

export type SearchParamTypeMapType = typeof SEARCH_PARAM_TYPE_MAPPING;
